module.exports = __webpack_public_path__ + "img/regimen.347c1c19.png";